import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/stats/"

// initial state
const state = {
  data: [],
  status: false
}

// getters
const getters = {
  getAll: state => {
    return state.data
  },
  getStatus: state => {
    return state.status
  }
}

// actions
const actions = {
  getByInstituicao({ commit }, id) {
    return axios
      .post(TABLE, _TOKEN({ id_instituicao: id }))
      .then(res => {
        _DECODE(res.data.data).then(r => {
          if (r) commit("setData", r)
          else commit("setData", null)
        })
      })
      .catch(err => {
        commit("setData", null)
      })
  }
}

// mutations
const mutations = {
  setData(state, data) {
    state.status = false
    state.data = data ? data : []

    setTimeout(() => {
      state.status = true
    }, 110)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
